import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

type IssuedSchedule = { year: number; month: number; schedule_id: string };

function scheduleValue(schedule: IssuedSchedule): string {
  return `${schedule.year}-${schedule.month}-${schedule.schedule_id}`;
}

function RosterListButton({
  issuedList,
  currentScheduleDate,
  setCurrentScheduleDate,
  variant = "default",
  viewLabel,
}: {
  issuedList: readonly IssuedSchedule[];
  currentScheduleDate: IssuedSchedule;
  setCurrentScheduleDate: (value: IssuedSchedule) => void;
  variant?: "default" | "title";
  viewLabel?: string;
}) {
  const hasCurrentMonth = issuedList.some(
    (item) =>
      item.year === currentScheduleDate.year &&
      item.month === currentScheduleDate.month
  );
  const options = hasCurrentMonth
    ? issuedList
    : [...issuedList, { ...currentScheduleDate, schedule_id: "" }].sort(
        (left, right) => right.year - left.year || right.month - left.month
      );
  const suffix = viewLabel
    ? ` ${viewLabel}`
    : variant === "title"
      ? " 근무표"
      : "";
  const selected =
    options.find(
      (item) => scheduleValue(item) === scheduleValue(currentScheduleDate)
    ) ??
    options.find(
      (item) =>
        Number(item.year) === Number(currentScheduleDate.year) &&
        Number(item.month) === Number(currentScheduleDate.month)
    );

  return (
    <Select
      value={selected ? scheduleValue(selected) : ""}
      disabled={options.length === 0}
      onValueChange={(value) => {
        const schedule = options.find((item) => scheduleValue(item) === value);
        if (schedule) setCurrentScheduleDate(schedule);
      }}
    >
      <SelectTrigger
        aria-label="근무표 연월 선택"
        className={
          variant === "title"
            ? "w-[280px] data-[size=default]:h-12 rounded-none border-0 border-b border-border shadow-none text-[22px] font-semibold"
            : "w-[180px]"
        }
      >
        <SelectValue
          placeholder={`${currentScheduleDate.year}년 ${currentScheduleDate.month}월${suffix}`}
        >
          {selected
            ? `${selected.year}년 ${selected.month}월${suffix}`
            : undefined}
        </SelectValue>
      </SelectTrigger>
      <SelectContent position="popper" align="start">
        <SelectGroup>
          {options.map((item) => (
            <SelectItem key={scheduleValue(item)} value={scheduleValue(item)}>
              <span>
                {item.year}년 {item.month}월{suffix}
              </span>
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}

export default RosterListButton;
